import request from "@/api/Request";

let bookingTimeRangStatusUrl = "/api/v1/booking_time_range_status";
let bookingSlotTypeUrl = "/api/v1/booking_slot_type";
let couponUrl = "/api/v1/coupon";
let bookingUrl = "/api/v1/booking";

let BookingApi = {
    getByTimeRangeAndDate(selectedTimeRangCode, orderedDate) {
        return request.get(
            bookingTimeRangStatusUrl + "/getByTimeRangeAndDate?timeRangeCode=" + selectedTimeRangCode + "&date="+ orderedDate,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    getByBookingTimeRange(timeRangeCode) {
        return request.get(
            bookingSlotTypeUrl + "/getByBookingTimeRange?timeRangeCode=" + timeRangeCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    verifyCouponForBookingOfEndUser(couponNumber, timRangeCode) {
        return request.get(
            couponUrl + "/verifyCouponForBookingOfEndUser?couponNumber=" + couponNumber + "&timeRangeCode=" + timRangeCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    createBooking(createBookingDto) {
        return request.post(
            bookingUrl + "/end_user/create",
            createBookingDto,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    createBookingPaymentIntent(amount) {
        const formData = new FormData();
        formData.set("amount", amount)
        return request.post(
            bookingUrl + "/create-booking-payment-intent",
            formData
        )
    },

    notifyPaymentSuccess(bookingId, paymentIntentId) {
        const formData = new FormData();
        formData.set("bookingId", bookingId)
        formData.set("paymentIntentId", paymentIntentId)
        return request.post(
            bookingUrl + "/payment-success",
            formData
        )
    },

    notifyPaymentFailed(bookingId, paymentIntentId) {
        const formData = new FormData();
        formData.set("bookingId", bookingId)
        formData.set("paymentIntentId", paymentIntentId)
        return request.post(
            bookingUrl + "/payment-failed",
            formData
        )
    },

    changeBookingDate(bookingCode,newTimeRangeCode,bookingDate){
        let changeBookingRequest = {
            bookingCode: bookingCode,
            newTimeRangeCode: newTimeRangeCode,
            bookingDate : bookingDate
        };
        return request.post(
            bookingUrl + "/changeBookingDate",
            changeBookingRequest,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    }
};

export default BookingApi;